import { gql } from "@apollo/client";

export const newTaskGroupMutation = gql`
    mutation($input: TaskLibraryGroupInput!){
        newTaskLibraryGroup(input: $input) {
            message
            response
        }
    }
`;


export const updateTaskGroupMutation = gql`
mutation($input: TaskLibraryGroupInput!){
  updateTaskLibraryGroup(input: $input) {
    message
    response
  }
}
`;


export const deleteTaskGroupMutation = gql`
mutation($id: String!){
  deleteTaskLibraryGroupById(_id: $id) {
    message
    response
  }
}
`;